export default __webpack_public_path__ + "static/videographers-741178664d13dd50ded1f78f2297758d.jpg";